import type { RecommendationsTab } from '@practium/features/recommendations';

const RECOMMENDATIONS_TABS: readonly RecommendationsTab[] = ['correction', 'maintenance', 'foliar'];

export const isRecommendationsTab = (value: string | null): value is RecommendationsTab =>
	RECOMMENDATIONS_TABS.includes(value as RecommendationsTab);

export const getRecommendationsListPath = (tab: RecommendationsTab) => `/recomendacoes?tab=${tab}`;
